import React from 'react';
import { Card, CardContent, Typography, Box } from '@mui/material';
import { TrendingUp, TrendingDown } from '@mui/icons-material';

/**
 * MetricCard — Reusable KPI card component.
 *
 * @param {string} label - Metric label (e.g. "Portfolio Value")
 * @param {string|number} value - Display value (e.g. "$125,430")
 * @param {React.ReactNode} [icon] - Optional icon element
 * @param {{ value: number, label: string }} [trend] - Optional trend (positive = green, negative = red)
 * @param {string} [color] - Optional MUI color override for the value text
 */
const MetricCard = ({ label, value, icon, trend, color }) => {
  return (
    <Card sx={{ height: '100%' }}>
      <CardContent sx={{ py: 2, px: 2.5, '&:last-child': { pb: 2 } }}>
        <Box display="flex" alignItems="center" gap={1} mb={0.5}>
          {icon && (
            <Box sx={{ color: 'text.secondary', display: 'flex', fontSize: 20 }}>
              {icon}
            </Box>
          )}
          <Typography
            variant="caption"
            sx={{
              color: 'text.secondary',
              textTransform: 'uppercase',
              letterSpacing: '0.5px',
              fontWeight: 600,
              fontSize: '0.7rem',
            }}
          >
            {label}
          </Typography>
        </Box>
        <Typography
          variant="h5"
          sx={{
            fontWeight: 700,
            color: color || 'text.primary',
            fontSize: '1.4rem',
          }}
        >
          {value}
        </Typography>
        {trend && (
          <Box display="flex" alignItems="center" gap={0.5} mt={0.5}>
            {trend.value >= 0 ? (
              <TrendingUp sx={{ fontSize: 16, color: 'success.main' }} />
            ) : (
              <TrendingDown sx={{ fontSize: 16, color: 'error.main' }} />
            )}
            <Typography
              variant="caption"
              sx={{
                fontWeight: 600,
                color: trend.value >= 0 ? 'success.main' : 'error.main',
              }}
            >
              {trend.label}
            </Typography>
          </Box>
        )}
      </CardContent>
    </Card>
  );
};

export default MetricCard;
